import React, { useState, useEffect } from "react";
import { Menu, X, Calendar, LayoutGrid, Info, Image as ImageIcon, PhoneCall, Home, Sparkles } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import "../styles/MyApp.css";

export default function Navbar({ onBookClick }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu when route changes
  useEffect(() => {
    setMobileMenu(false);
  }, [location]);

  const navItems = [
    { name: "Home", path: "/", icon: <Home size={18} /> },
    { name: "Services", path: "/services", icon: <LayoutGrid size={18} /> },
    { name: "Gallery", path: "/gallery", icon: <ImageIcon size={18} /> },
    { name: "About", path: "/about", icon: <Info size={18} /> },
    { name: "Contact", path: "/contact", icon: <PhoneCall size={18} /> },
  ];

  const mobileNavItems = [
    { name: "Home", path: "/", icon: <Home size={20} /> },
    { name: "Services", path: "/services", icon: <Sparkles size={20} /> },
    { name: "About", path: "/about", icon: <Info size={20} /> },
  ];

  return (
    <>
    <nav className={`nav-wrapper ${isScrolled ? "scrolled" : ""}`}>
      <div className="nav-main">
        {/* LOGO AREA */}
        <div className="nav-brand">
          <Link to="/">
            <img src="/assets/logo/logo.png" alt="Deyfresh Logo" className="nav-logo" />
          </Link>
        </div>

        {/* MOBILE OVERLAY / DESKTOP CAPSULE */}
        <div 
          className={`nav-capsule ${mobileMenu ? "mobile-open" : ""}`}
          onClick={() => setMobileMenu(false)} // Dismiss menu when clicking background
        >
          <div className="nav-items-container" onClick={(e) => e.stopPropagation()}>
            {navItems.map((item) => (
              <Link 
                key={item.name} 
                to={item.path} 
                className={`nav-link-item ${location.pathname === item.path ? "active" : ""}`}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-text">{item.name}</span>
              </Link>
            ))}
          </div>
        </div>

        {/* ACTIONS & TOGGLE */}
        <div className="nav-actions">
          <button className="app-book-btn" onClick={onBookClick}>
            <Calendar size={18} />
            <span className="btn-label">BOOK NOW</span>
          </button>
          
          <button 
            className={`menu-toggle ${mobileMenu ? "toggle-active" : ""}`} 
            onClick={() => setMobileMenu(!mobileMenu)}
          >
            {mobileMenu ? <X size={28} strokeWidth={2.5} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

    </nav>

      <div className="mobile-bottom-nav" aria-label="Mobile navigation">
        <Link to="/" className={`mobile-tab ${location.pathname === "/" ? "active" : ""}`}>
          <Home size={20} />
          <span>Home</span>
        </Link>
        <Link to="/services" className={`mobile-tab ${location.pathname === "/services" ? "active" : ""}`}>
          <Sparkles size={20} />
          <span>Services</span>
        </Link>
        <button className="mobile-book-tab" onClick={onBookClick} aria-label="Book appointment">
          <span className="mobile-book-icon"><Calendar size={22} /></span>
          <span>Book</span>
        </button>
        <Link to="/about" className={`mobile-tab ${location.pathname === "/about" ? "active" : ""}`}>
          <Info size={20} />
          <span>About</span>
        </Link>
        <Link to="/contact" className={`mobile-tab ${location.pathname === "/contact" ? "active" : ""}`}>
          <PhoneCall size={20} />
          <span>Contact</span>
        </Link>
      </div>
    </>
  );
}